var map = {
	"./icon_disadvantage_01operater.png": 15,
	"./icon_disadvantage_02operater.png": 20,
	"./icon_disadvantage_03operater.png": 21,
	"./icon_disadvantage_04operater.png": 22,
	"./icon_disadvantage_05operater.png": 23,
	"./icon_disadvantage_06operater.png": 24,
	"./icon_disadvantage_07operater.png": 25,
	"./icon_disadvantage_08operater.png": 26,
	"./icon_disadvantage_09operater.png": 27,
	"./icon_disadvantage_10operater.png": 28,
	"./icon_disadvantage_11operater.png": 29,
	"./icon_disadvantage_12operater.png": 30,
	"./icon_disadvantage_13operater.png": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 406;